import { runListAction } from "../../services/api/Api";
import { Message } from "../../components/BP2Components";

export const googleNav = async ({ actionId, recordId, intl, actionKey = null }) => {
   try {
      const response = await runListAction(actionId, recordId, actionKey);
      const navUrlFromApi = response?.data?.actions?.navUrl;
      if (navUrlFromApi) {
         window.open(navUrlFromApi, "_blank", "noopener,noreferrer");
      } else {
         Message.error(intl.formatMessage({ id: "actions.noGoogleNavUrl" }));
      }
   } catch (err) {
      Message.error(intl.formatMessage({ id: "actions.noGoogleNavUrl" }));
   }
};
